module.exports = __webpack_public_path__ + "img/google-play-badge.78ebd30e.png";